import React, { useEffect, useState } from "react";
import Masonry from "react-masonry-css";
import projects from "assets/projects_info";
import "./ProjectListPage.css";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    768: 2,
    500: 1
}


const ProjectListPage = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState(projects);

    const filterType = searchParams.get("filter") || "SHOW ALL";

    function filterData(event) {
        event.preventDefault();
        const newFilter = event.target.innerHTML;
        if (newFilter === "SHOW ALL") {
            setSearchParams({});
        } else {
            setSearchParams({ filter: newFilter });
        }
    }

    useEffect(() => {
        if (filterType === "SHOW ALL") {
            setData(projects);
        } else {
            let filteredData = projects.filter(project => project.type === filterType);
            setData(filteredData);
        }
    }, [filterType])

    return (

        <div className="projects-list">
            {/* <div className="title">WORK</div> */}

            <div className="projects-link-navbar">
                {["SHOW ALL", "RESIDENTIAL", "INSTITUTIONAL", "INDUSTRIAL"].map((filter) => (
                    <Link
                        key={filter}
                        className={`navbar-link ${filterType === filter ? 'active' : ''}`}
                        onClick={filterData}
                    >
                        {filter}
                    </Link>
                ))}
            </div>

            {data.length === 0 ? (
                <div className="coming-soon">
                    <p>Coming Soon</p>
                </div>
            ) : (
                <>
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="masonry-grid"
                        columnClassName="masonry-grid-column"
                    >
                        {data.map((item) => (
                            <div
                                key={item.id}
                                className="project-link"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                    navigate(`/work/${item.id}`);
                                }}
                            >
                                <div className="thumbnail-container">
                                    <img
                                        src={item.thumbnail}
                                        alt={`Thumbnail for ${item.name}`}
                                        className="thumbnail"
                                    />
                                </div>
                                <div className="project-name">
                                    <span>{item.title}</span>
                                </div>
                            </div>
                        ))}
                    </Masonry>
                    <div className="coming-soon">
                        <p>Coming Soon</p>
                    </div>
                </>
            )}
        </div>
    );
}

export default ProjectListPage;